var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFacebook(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.3238 10.8997V7.74116C15.3238 7.30289 15.5468 6.72209 16.2276 6.72209H18.5904V2.33333L14.1764 2.33333C12.6546 2.33333 10.4047 4.28228 10.4047 6.35014V10.7747H8.16666V15.1383L10.4232 15.1521L10.4232 25.5317H15.2876L15.2876 15.2039L18.6096 15.2039L19.4137 10.8997L15.3238 10.8997Z",
    fill: "#1877F2"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebook);
export default __webpack_public_path__ + "static/media/facebook.d75ba820530795d4194d35a53e822f18.svg";
export { ForwardRef as ReactComponent };